import React from "react";
import {NomenclaturesNoCategoryPage} from "./NomenclaturesNoCategoryPage";
import {useNomenclaturesNoCategory} from "./useNomenclaturesNoCategory";

function NomenclaturesNoCategory() {
  return <NomenclaturesNoCategoryPage {...useNomenclaturesNoCategory()} />;
}

export default NomenclaturesNoCategory;
